import { render, staticRenderFns } from "./AutocompleteSuggestionItem.vue?vue&type=template&id=96bfa6fe&scoped=true&"
import script from "./AutocompleteSuggestionItem.vue?vue&type=script&lang=ts&"
export * from "./AutocompleteSuggestionItem.vue?vue&type=script&lang=ts&"
import style0 from "./AutocompleteSuggestionItem.vue?vue&type=style&index=0&id=96bfa6fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bfa6fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96bfa6fe')) {
      api.createRecord('96bfa6fe', component.options)
    } else {
      api.reload('96bfa6fe', component.options)
    }
    module.hot.accept("./AutocompleteSuggestionItem.vue?vue&type=template&id=96bfa6fe&scoped=true&", function () {
      api.rerender('96bfa6fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/items/AutocompleteSuggestionItem.vue"
export default component.exports